import React, {useContext, useEffect} from 'react';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import TableCell, {tableCellClasses} from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import TableContainer from "@mui/material/TableContainer";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import {useNavigate} from "react-router-dom";
import InputBase from "@mui/material/InputBase";
import moment from "moment";
import PostNotification from "../../helpers/post-notification";
import {AuthUserContext} from "../../providers/AuthProvider";
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: 'none',
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));
const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: '#F1F4F8',
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

const BootstrapInput = styled(InputBase)(({ theme }) => ({
  'label + &': {
    marginTop: theme.spacing(3),
  },
  '& .MuiInputBase-input': {
    borderRadius: 30,
    position: 'relative',
    backgroundColor: '#204488',
    border: 'none',
    fontSize: 16,
    width: 80,
    color: '#fff',
    padding: '10px 26px 10px 12px',
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    '&:focus': {
      borderRadius: 30,
      borderColor: 'none',
      boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
    },
  },
}));

export default function ManageProjectsDeadlines({contracts, project, receipts}){
  const {profile} = useContext(AuthUserContext);
  const navigator = useNavigate()
  const [total, setTotal] = React.useState(0)
  const [isLoading, setLoading] = React.useState(false)
  useEffect(()=>{
    if (contracts && contracts.length > 0) {
      let t = 0;
      for(let contract of receipts){
        if (contract.amount && typeof parseInt(contract.amount) === 'number') {
          if (parseInt(contract.amount) != NaN) {
             
            t += parseInt(contract.amount);
          }
        }
        console.log(t, 'TOTAL INVESTMENT')
        setTotal(t)
      }
    }

  }, [contracts])

  const fullyFunded = async () => {
    setLoading(true)
    try {

      if (contracts.length > 0) {
        for (let contract of contracts) {
          /*
          * Investor notification
          * */
          await PostNotification({
            title: 'Project fully funded',
            text: 'We are excited to inform that the payment was received. See project here',
            uid: contract.uid,
            createdBy:profile?.uid,
            link: `/investor/project-show-interest/${project.id}`,
          })
        }
      }
      /*
       * creator notification
       *
       * */
      await PostNotification({
        title: 'Project fully funded',
        text: 'We are excited to inform that the payment was received. See project here',
        uid: project.uid,
        createdBy:profile?.uid,
        link: `/creator/project-details/${project.id}`,
      })
      setLoading(false)

    } catch (e) {
      setLoading(false)

    }

  }
  const deadlineReached = async () => {
    setLoading(true)
    try {
      if (contracts.length > 0) {
        for (let contract of contracts) {
          /*
          * Investor notification
          * */
          await PostNotification({
            title: 'The project deadline',
            text: 'The project deadline was reached We raised the threshold amount The project can now start.',
            uid: contract.uid,
            createdBy:profile?.uid,
            link: `/investor/project-show-interest/${project.id}`,
          })
        }
      }
      setLoading(false)
    } catch (e) {
      setLoading(false)
    }
    
  }
  return (
    <Stack direction={'column'} spacing={5}>
      <TableContainer >
        <Table sx={{ minWidth: 700 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <StyledTableCell sx={{fontWeight: 'bolder', fontSize:16, }}>Creator</StyledTableCell>
              <StyledTableCell  align="center"  sx={{fontWeight: 'bolder', fontSize:16, }}>Profile</StyledTableCell>
              <StyledTableCell align="center" sx={{fontWeight: 'bolder', fontSize:16, }}>Project name</StyledTableCell>
              <StyledTableCell align="center" sx={{fontWeight: 'bolder', fontSize:16}}>Investment raised</StyledTableCell>
              <StyledTableCell align="center" sx={{fontWeight: 'bolder', fontSize:16, }}>Target investment</StyledTableCell>
              <StyledTableCell align="center" sx={{fontWeight: 'bolder', fontSize:16, }}>Threshold Amount</StyledTableCell>
              <StyledTableCell align="center" sx={{fontWeight: 'bolder', fontSize:16, }}>Deadline</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>

            <StyledTableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
              <StyledTableCell  component="th" scope="row">
                <Typography noWrap={true}>{project?.creatorName || project?.uid}</Typography>
              </StyledTableCell>
              <StyledTableCell   align="center">
              <Button variant={'text'} color={'primary'} sx={{textDecoration: 'underline'}} onClick={() => navigator('/admin/user-details/' + project?.uid)}>View</Button>
              </StyledTableCell>
              <StyledTableCell   align="center">
                <Typography noWrap={true} >
                  {project.title}
                </Typography>
              </StyledTableCell>
              <StyledTableCell   align="center">
                <Typography noWrap={true} >
                  {total}
                </Typography>
              </StyledTableCell>
              <StyledTableCell   align="center">
                <Typography noWrap={true} >
                  {project?.budget}
                </Typography>
              </StyledTableCell>
              <StyledTableCell   align="center">
                <Typography noWrap={true} >
                  {+project?.budget - total}
                </Typography>
              </StyledTableCell>
              <StyledTableCell   align="center">
                <Typography noWrap={true} >
                  {moment(project?.investmentDeadline).format('MMM D, yyyy')}
                </Typography>
              </StyledTableCell>
            </StyledTableRow>

          </TableBody>
        </Table>
      </TableContainer>

      <Typography variant={'h5'}>Notify Investors on project status</Typography>

      <Stack direction={'row'} spacing={5}>
        <Button  color={'primary'}  sx={{backgroundColor:'#E3E8F0', px: 5}} disabled={isLoading} onClick={fullyFunded}>Fully funded</Button>
        <Button  color={'primary'}  sx={{backgroundColor:'#E3E8F0', px: 5}}  disabled={isLoading}  >Deadline approaching*</Button>
        <Button  color={'primary'}  sx={{backgroundColor:'#E3E8F0', px: 5}}  disabled={isLoading}  onClick={deadlineReached}>Threshold reached**</Button>
        <Button  color={'primary'}  sx={{backgroundColor:'#E3E8F0', px: 5}}  disabled={isLoading}  >Threshold not reached**</Button>
      </Stack>
      <Typography variant={'body2'} sx={{lineHeight: 1.8}}>
        *This notification should be sent 3 weeks prior to deadline. <br/>
        **This notification should only be sent once the deadline is reached.
      </Typography>

    </Stack>
  )
}